import { log } from '../app/logger.js';

class EventRacer {
  constructor(el, evs) {
    this.el = el;
    this.evs = evs;
  }

  race(cb) {
    this.cb = cb;
    for (let ev of this.evs) {
      this.el.addEventListener(ev, this, true);
    }
  }

  break() {
    for (let ev of this.evs) {
      this.el.removeEventListener(ev, this, true);
    }
  }

  handleEvent(ev) {
    log(`[eventrace] event ${ev.type} is fired on ${ev.target}`);
    this.cb('racer');
  }
}

/**
 * Races an action promise against events fired on an element. If action promise
 * wins, then action is invoked.
 */
const raceWithEvents = ({ action, actionPromise, element, events }) => {
  let evracer = new EventRacer(element, events);
  return Promise.race([actionPromise, new Promise(r => evracer.race(r))]).then(
    winner => {
      evracer.break();
      if (winner != 'racer') {
        action();
      }
    }
  );
};

export { raceWithEvents };
